// eslint-disable-next-line prefer-destructuring
const env = import.meta.env;

export default env;
